import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '@/page/home'
import login from '@/page/login'
import hospManage from '@/page/hospManage'
import hospDetail from '@/page/hospDetail'
import docManage from '@/page/docManage'
import caseList from '@/page/caseList'
import staffManage from '@/page/staffManage'
import finance from '@/page/finance'
import financeDetail from '@/page/financeDetail'
import statistics from '@/page/statistics'
import regionData from '@/page/regionData'
import logUser from '@/page/logUser'
Vue.use(VueRouter)

const routers={
  mode: 'history',
  routes:[
    {
      path:'/',
      redirect:'/login'
    },
    {
      path:'/login',
      name: 'login',
      component: login,
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      children:[
        {
          path:'/hospManage',
          name:'hospManage',
          component:hospManage
        },
        {
          path:'/hospDetail',
          name:'hospDetail',
          component:hospDetail
        },
        {
          path:'/docManage',
          name:'docManage',
          component:docManage
        },
        {
          path:'/caseList',
          name:'caseList',
          component:caseList
        },
        {
          path:'/staffManage',
          name:'staffManage',
          component:staffManage
        },
        {
          path:'/finance',
          name:'finance',
          component:finance
        },
        {
          path:'/financeDetail',
          name:'financeDetail',
          component:financeDetail
        },
        {
          path:'/statistics',
          name:'statistics',
          component:statistics
        },
        {
          path:'/regionData',
          name:'regionData',
          component:regionData
        },
        {
          path:'/logUser',
          name:'logUser',
          component:logUser
        }
      ]
    }
  ]
}
const router=new VueRouter(routers);
router.beforeEach(function (to, from, next) {
  //跳转至上述3个页面
  if(to.path === '/login') {
    if (window.sessionStorage.getItem('userInfo')) {
      next({ name:'home'})
    }
    next()
  } 
  else {
    if(to.meta.requiresAuth && !sessionStorage.getItem('userInfo')) {
      router.push({name: 'login'})
    }else{
      next()
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js